
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class TableEmpty extends Vue {}
